import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import TextInput from "../../TextInput";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from 'react-select';
import { fetchCities, fetchDistricts, fetchProvinces, fetchSubdistricts } from "../../../redux/actions/regions";

const ModalAlamat = ({
    toggle,
    modal,
    data,
    submit
}) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, setValue, watch, control, formState: { errors } } = useForm({});
    const { provinces, cities, districts, subdistricts } = useSelector((state) => state.region);

    useEffect(() => {
        if (!data) return

        reset({
            label: data.label,
            nama: data.nama,
            phone: data.phone,
            alamat: data.alamat,
            public_id: data.public_id,
        })

        data.is_default ?? reset({ is_default: data.is_default })
    }, [data])

    useEffect(() => {
        if (modal && (!provinces || provinces.length === 0)) {
            dispatch(fetchProvinces());
        }
    }, [dispatch, modal, provinces]);


    const selectedProvinsi = watch("provinsi");
    const selectedKota = watch("kota");
    const selectedKelurahan = watch("kelurahan");
    const selectedKecamatan = watch("kecamatan");

    
    /// provinsi ///
    useEffect(() => {
        if (!provinces) return
        if (selectedProvinsi && provinces.length > 0) {
            const found = provinces.find(d => d.name === selectedProvinsi.value);
            if (found?.id) {
                setValue("kota", null);
                setValue("kecamatan", null);
                setValue("kelurahan", null);
                setValue("kode_pos", null);
                dispatch(fetchCities({ province_id: found.id }));
            }
        }
    }, [selectedProvinsi, provinces]);

    useEffect(() => {
        if (!data?.provinsi || !provinces) return
        const found = provinces.find(d => d.name === data?.provinsi);
        if (found?.id) {
            setValue("provinsi", {
                value: found.name,
                label: found.name
            })
        }
    }, [data, provinces]);

    /// kota ///
    useEffect(() => {
        if (!cities) return
        if (selectedKota && cities.length > 0) {
            const found = cities.find(d => d.name === selectedKota.value);
            if (found?.id) {
                setValue("kecamatan", null);
                setValue("kelurahan", null);
                setValue("kode_pos", null);
                dispatch(fetchDistricts({ city_id: found.id }));
            }
        }
    }, [selectedKota, cities]);

    useEffect(() => {
        if (!data?.kota || !cities) return
        const found = cities.find(d => d.name === data?.kota);
        if (found?.id) {
            setValue("kota", {
                value: found.name,
                label: found.name
            })
        }
    }, [data, cities]);

    /// kecamatan ///
    useEffect(() => {
        if (!districts) return
        if (!selectedKecamatan || districts.length <= 0) return
        const found = districts.find(d => d.name === selectedKecamatan.value);
        if (found?.id) {
            setValue("kelurahan", null);
            setValue("kode_pos", null);
            dispatch(fetchSubdistricts({ district_id: found.id }));
        }
    }, [selectedKecamatan, districts]);

    useEffect(() => {
        if (!data?.kecamatan || !districts) return
        const found = districts.find(d => d.name === data?.kecamatan);
        if (found?.id) {
            setValue("kecamatan", {
                value: found.name,
                label: found.name
            })
        }
    }, [data, districts]);

    /// kelurahan ///
    useEffect(() => {
        if (!subdistricts) return
        if (!selectedKelurahan || subdistricts.length <= 0) return
        const found = subdistricts.find(d => d.name === selectedKelurahan.value);
        if (found?.id) {
            setValue("kode_pos", found.zip_code);
            setValue("kelurahan_id", found?.id)
        }
    }, [selectedKelurahan, subdistricts]);

    useEffect(() => {
        if (!data?.kelurahan || !subdistricts) return
        const found = subdistricts.find(d => d.name === data?.kelurahan);
        if (found?.id) {
            setValue("kelurahan", {
                value: found.name,
                label: found.name
            })
        }
    }, [data, subdistricts]);

    useEffect(() => {
        if (!data) {
            reset({})
        }
    }, [data])


    const onSubmit = (data) => {
        const result = {
            ...data,
            provinsi: data.provinsi.value,
            kota: data.kota.value,
            kecamatan: data.kecamatan.value,
            kelurahan: data.kelurahan.value
        }


        submit(result, data ? "update" : "create");
        toggle();
    };

    return (
        <Modal
            toggle={toggle}
            isOpen={modal}
            centered
            size="lg"
            className="font-sans"
        >
            <ModalHeader
                toggle={toggle}
                close={
                    <div className="btn close" onClick={toggle}>
                        ×
                    </div>
                }
            >
                {data ? "Ubah" : "Tambah"} Alamat
            </ModalHeader>
            <ModalBody className="p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <TextInput
                                layout="vertical"
                                label="Label"
                                type="text"
                                register={register}
                                errors={errors}
                                name="label"
                                placeholder="Masukkan label pengiriman"
                                validations={{ required: "Masukkan label pengiriman" }}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <TextInput
                                layout="vertical"
                                label="Nama Penerima"
                                type="text"
                                register={register}
                                errors={errors}
                                name="nama"
                                placeholder="Masukkan nama penerima"
                                validations={{ required: "Masukkan nama penerima" }}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <TextInput
                                layout="vertical"
                                label="No Telp Penerima"
                                type="number"
                                register={register}
                                name="phone"
                                placeholder="Masukkan nomor telepon"
                                validations={{ required: "Masukkan nomor telepon" }}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <hr />

                    <div className="row">
                        <div className="col-md-4 mb-4">
                            <label
                                htmlFor={'provinsi'}
                                className={
                                    `font-weight-bold`
                                }>
                                Provinsi
                            </label>
                            <Controller
                                name="provinsi"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        options={provinces?.map((v) => ({
                                            value: v.name,
                                            label: v.name
                                        }))}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label
                                htmlFor={'kota'}
                                className={
                                    `font-weight-bold`
                                }>
                                Kota
                            </label>

                            <Controller
                                name="kota"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        options={cities?.map((v) => ({
                                            value: v.name,
                                            label: v.name
                                        }))}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label
                                htmlFor={'kecamatan'}
                                className={
                                    `font-weight-bold`
                                }>
                                Kecamatan
                            </label>
                            <Controller
                                name="kecamatan"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        options={districts?.map((v) => ({
                                            value: v.name,
                                            label: v.name
                                        }))}
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 mb-4">
                            <label
                                htmlFor={'kelurahan'}
                                className={
                                    `font-weight-bold`
                                }>
                                Kelurahan
                            </label>
                            <Controller
                                name="kelurahan"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        options={subdistricts?.map((v) => ({
                                            value: v.name,
                                            label: v.name
                                        }))}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <TextInput
                                layout="vertical"
                                label="Kode Pos"
                                type="text"
                                register={register}
                                name="kode_pos"
                                readOnly
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <TextInput
                                layout="vertical"
                                label="Alamat lengkap pengiriman"
                                type="textarea"
                                register={register}
                                errors={errors}
                                name="alamat"
                                placeholder="Contoh: Jl. Melati No.12 RT 03 RW 05"
                                validations={{ required: "Alamat lengkap pengiriman tidak boleh kosong" }}
                                className="form-control"
                            />
                        </div>
                        {
                            data?.is_default !== true && <div className="col-md-12 mb-3">
                                <TextInput
                                    layout="vertical"
                                    label="Atur sebagai Alamat Utama"
                                    type="switch"
                                    register={register}
                                    errors={errors}
                                    defaultValue={watch("is_default")}
                                    name="is_default"
                                    className="form-control"
                                />
                            </div>
                        }

                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <div>
                            {data ? (
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        submit({ public_id: data.public_id }, "delete");
                                        toggle();
                                    }}
                                >
                                    <i className="fas fa-trash"></i> Hapus
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={toggle}
                                >
                                    Tutup
                                </button>
                            )}
                        </div>
                        <button type="submit" className="btn btn-primary">
                            Simpan
                        </button>
                    </div>
                </form>
            </ModalBody>
        </Modal>
    )
}

export default ModalAlamat;